import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';

import ValidadorApi from '../../../logicas/Validador/ValidadorApi';
import FormValidador from './FormValidador';
import FormValidadorPorCertificado from './FormValidadorPorCertificado';

// import ItensSeguranca from '../../../assets/images/dne-itens-seguranca-2024-new.png';
import ItensSeguranca from '../../../assets/images/DNE-MEIA ENTRADA.webp';

const scrollPage = (props) => {
  const currentPage = props.match.params.page;

  let element;
  let topToScroll = 0;

  if (currentPage !== "") {
    if (currentPage === "itens-de-seguranca") {
      element = document.getElementById('itensDeSeguranca');
      topToScroll = (element.offsetTop - 140);
    } else if (currentPage === "integracao") {
      element = document.getElementById('integreSeuSistema');
      topToScroll = (element.offsetTop - 120);
    }
  }

  window.scrollTo(0, topToScroll);
};

class Validador extends Component {
  constructor() {
    super();
    this.state = {validarPor: "codigoUso"}
  }

  componentDidUpdate() {
    scrollPage(this.props);
  }

  componentDidMount() {
    scrollPage(this.props);
  }

  alterarTipoValidacao = (changeEvent) => {
    this.setState({
      validarPor: changeEvent.target.value
    });
  };

  render() {

    const validarCie = (values) => {
      let dataNumbers = values.dataNascimento.replace(/[^\d]/g, '');
      let dataFormat = `${dataNumbers.slice(4, 8)}${dataNumbers.slice(2, 4)}${dataNumbers.slice(0, 2)}`;
      this.props.history.push(`/validador/${values.codigoUso}/${dataFormat}`)
    };

    const validarCiePorCertificado = (values) => {
      new Promise(resolve => {
        this.props.validarDocumentoPorCertificado(values.certificadoAtributo, resolve, reset);
      })
    };

    return (
      <div>
        <section className="bg-blue-meiaentrada divisao-sessao divisao-sessao-bottom py-5 text-light">
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h1>Valide a Carteira de <br/> Identificação Estudantil (CIE)</h1>
              </div>
            </div>
          </div>
          <div className="container">

            <div className="row align-items-center">

              <div className="col-md-6 col-lg-7 order-md-2">
                <p>
                  É possível verificar a autenticidade de uma Carteira de Identificação Estudantil (CIE) das seguintes
                  formas:
                </p>

                <ul>
                  <li className='py-2'>
                    Mediante validação do número do registro da CIE.
                  </li>
                  <li className='py-2'>
                    Pela leitura do QR-Code (Código de Resposta Rápida) presente em todas as Carteiras de Identificação
                    Estudantil (CIE). O validador possibilita a consulta em tempo real se o certificado digital é válidos,
                    atestando a condição de estudante do seu portador.
                  </li>
                  <li className='py-2'>
                    As seguintes características também podem ser observadas:
                    <ul>
                      <li>Cartão do tipo PVC</li>
                      <li>Fundo de tramas com efeito anti-scanner</li>
                      <li>Impressões de textos em microletras</li>
                      <li>Tinta sensível à luz ultravioleta e infravermelha (opcional)</li>
                    </ul>
                  </li>
                </ul>
              </div>


              <div className="col-md-6 col-lg-5 col-xl-4">

                <div className="row justify-content-center py-4 px-3 form-style">
                  <div className="col">

                    {/*<div className='form-group'>*/}
                      {/*<label>Validar por</label>*/}
                      {/*<div className="d-flex justify-content-center">*/}
                        {/*<div className="btn-group btn-group-toggle">*/}
                          {/*<label*/}
                            {/*className={`btn ${this.state.validarPor === "codigoUso" ? "btn-primary " : "btn-tertiary"}`}>*/}
                            {/*<input type="radio" name='radioTipo' value='codigoUso' ref='radioTipo' className='d-none'*/}
                                   {/*checked={this.state.validarPor === "codigoUso"}*/}
                                   {/*onChange={this.alterarTipoValidacao}/> Código de uso*/}
                          {/*</label>*/}

                          {/*<label*/}
                            {/*className={`btn ${this.state.validarPor !== "codigoUso" ? "btn-primary " : "btn-tertiary"}`}>*/}
                            {/*<input type="radio" name='radioTipo' value='certificadoAtributo' ref='radioTipo'*/}
                                   {/*checked={this.state.validarPor === "certificadoAtributo"} className='d-none'*/}
                                   {/*onChange={this.alterarTipoValidacao}/> Certificado de Atributo*/}
                          {/*</label>*/}
                        {/*</div>*/}
                      {/*</div>*/}

                    {/*</div>*/}


                    <div className={this.state.validarPor !== "codigoUso" ? 'd-none' : ''}>
                      <FormValidador onSubmit={validarCie}/>
                    </div>

                    <div className={this.state.validarPor === "codigoUso" ? 'd-none' : ''}>
                      <FormValidadorPorCertificado onSubmit={validarCiePorCertificado}/>
                    </div>
                  </div>
                </div>

                {this.props.validacaoStatus.status !== undefined ? (
                  <div
                    className={`row px-3 alert mt-2 text-center ${this.props.validacaoStatus.status ? 'alert-success' : 'alert-success'}`}>
                    <p className='mb-0 d-block w-100'>
                      <b>{this.props.validacaoStatus.status ? "Documento válido" : "Documento inválido"}</b></p>
                    <p className='mb-0 d-block w-100'>
                      {this.props.validacaoStatus.msg}
                    </p>
                  </div>
                ) : ''}
              </div>

              <div className="d-none d-xl-block col-xl-1"/>
            </div>
          </div>
        </section>

        <section className="py-4" id="itensDeSeguranca">
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h2>Itens de segurança da Carteira <br/> de Identificação Estudantil (CIE)</h2>
              </div>
            </div>
          </div>
          <div className="container">

            <div className="row justify-content-between">
              <div className="text-center col-md-6">
                <img src={ItensSeguranca} alt="Itens de segurança"/>
              </div>

              <div className="col-md-5">
                <p>
                  <b>ATENÇÃO! </b> Por questões de segurança, o layout e posicionamento dos itens de segurança são
                  alterados anualmente. Por isso, as entidades nacionais de representação estudantil publicam, por volta
                  do dia 1º de dezembro do ano anterior, as características físicas e visuais do Padrão Nacional da
                  Carteira de Identificação Estudantil (CIE), que devem ser seguidas por todas as entidades estudantis
                  emissoras da Carteira.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/*
        <section className="bg-blue-meiaentrada divisao-sessao divisao-sessao-top pb-5 text-light"
                 id="integreSeuSistema">
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h2>Integre seu sistema</h2>
              </div>
            </div>
          </div>
          <div className="container">

            <p>
              Os estabelecimentos, produtoras e promotoras de eventos podem integrar seus sistemas de vendas online
              diretamente com o validador, por meio de API, agilizando e automatizando o
              processo de vendas.
            </p>

            <div className="text-center">
              <Link to='/validador/integre' className='btn btn-success btn-lg text-light'>Integrar sistema </Link>
            </div>
          </div>
        </section>

        */}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    validacaoStatus: state.validacaoStatus
  }
};

const mapDispatchToProps = dispatch => {
  return {
    validarDocumentoPorCertificado: (values, resolve, reset) => {
      dispatch(ValidadorApi.validarDocumentoPorCertificado(values, resolve, reset))
    }
  }
};

const ValidadorContainer = connect(mapStateToProps, mapDispatchToProps)(Validador);

export default ValidadorContainer



// WEBPACK FOOTER //
// ./src/components/views/Validador/Validador.js